module.exports = __webpack_public_path__ + "img/lb2.cfc5298f.png";